import {
  StateCreator, UseBoundStore, StoreApi, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface TUploadErrorToastState {
  showMessage: boolean;
  messageList: ErrorMessage[];
}
interface ErrorMessage {
  message: {
    key: string;
    params?: Record<string, any>;
  };
  fileNum: number;
}
const uploadErrorToastSlice: StateCreator<TUploadErrorToastState, [
  ['zustand/immer', never],
]> = (set, get) => ({
  showMessage: false,
  messageList: [],
});
const useUploadErrorToastStore: UseBoundStore<StoreApi<TUploadErrorToastState>> = create<TUploadErrorToastState>()(immer(uploadErrorToastSlice));
export default useUploadErrorToastStore;

export function setUploadErrorToast(showMessage: boolean, messageList: ErrorMessage[] = []) {
  useUploadErrorToastStore.setState((state) => {
    return {
      showMessage,
      messageList,
    };
  });
}
